import type { Guide, GuideRecordHint } from '../types';

/**
 * S-21.10-19 — „Potwierdzam dane do publikacji” w oknie publikacji (scenariusz e2e 21, ścieżka MIX-03 krok 5; e2e 17).
 * Rekordy: DEMO/2026/10/C02 (typ JUMBO w zleceniu) i DEMO/2026/10/C04 — zlecenie w Trade bez typu pojazdu (dane pod
 * slajdy z 22.10.2026, `seed-e2e.ts`).
 */
const TRADE_ORDER: GuideRecordHint = {
  description: 'zlecenie w Trade, które można wystawić na giełdę',
  listPath: '/user-offers',
  listFilter: { forklift: 'hide', dzial: 'TRADE' },
};

export const guide: Guide = {
  flagKey: 'publicationDataConfirmation',
  title: 'Potwierdzenie danych do publikacji na giełdzie',
  whatItDoes:
    'W oknie „Wystaw na TIMOCOM / Trans.eu” jest nowy krok „Dane do publikacji — sprawdź i potwierdź”: typ pojazdu i zabudowa, długość ładunku, wysokość (TMS jej nie podaje, więc na giełdę idzie typ zabudowy) i wózek widłowy. Przy każdej wartości widać, skąd jest: podpowiedź z typu zlecenia, wybór ręczny albo — przy zleceniu bez typu pojazdu — wprost: „typu pojazdu w zleceniu brak; podpowiadamy domyślny typ floty (JUMBO), do sprawdzenia”. Bez zaznaczenia „Potwierdzam dane do publikacji” przycisk „Wystaw” jest nieaktywny, a wynik publikacji zapisuje, kto i kiedy potwierdził dane i jaki pojazd.',
  audience: ['Trade'],
  presentationItems: ['S-21.10-19'],
  steps: [
    {
      route: '/user-offers/:orderId/show',
      record: TRADE_ORDER,
      target: 'publication-data-confirmation',
      title: 'Dane do publikacji w oknie',
      description:
        'Pod podglądem oferty tabela danych, które pójdą na giełdę: typ pojazdu i zabudowa, długość ładunku, wysokość i wózek. Wartość z typu zlecenia to podpowiedź do potwierdzenia, nie wartość domyślna.',
      action: 'Kliknij „Wystaw na TIMOCOM” i sprawdź tabelę „Dane do publikacji”.',
      recorder: {
        account: 'trade',
        demo: { kind: 'order', number: 'DEMO/2026/10/C02' },
        actions: [{ kind: 'clickButton', name: 'Wystaw na TIMOCOM' }],
      },
    },
    {
      route: '/user-offers/:orderId/show',
      record: {
        description: 'zlecenie w Trade bez typu pojazdu w danych z TMS',
        listPath: '/user-offers',
        listFilter: { forklift: 'hide', dzial: 'TRADE' },
      },
      target: 'publication-data-confirmation',
      title: 'Zlecenie bez typu pojazdu',
      description:
        'Gdy zlecenie nie ma typu pojazdu, tabela mówi to wprost: „typu pojazdu w zleceniu brak; podpowiadamy domyślny typ floty (JUMBO), do sprawdzenia” — przy typie pojazdu i przy wózku. Potwierdzenie obejmuje wtedy także tę podpowiedź.',
      action: 'Kliknij „Wystaw na TIMOCOM”, sprawdź typ pojazdu i w razie potrzeby wybierz inny przed potwierdzeniem.',
      recorder: {
        account: 'trade',
        demo: { kind: 'order', number: 'DEMO/2026/10/C04' },
        actions: [{ kind: 'clickButton', name: 'Wystaw na TIMOCOM' }],
      },
    },
    {
      route: '/user-offers/:orderId/show',
      record: TRADE_ORDER,
      target: 'trd-zlecenie-dane-potwierdz',
      mockupTestId: 'trd-zlecenie-dane-potwierdz',
      title: 'Potwierdzenie danych',
      description:
        'Zaznaczenie potwierdza wszystkie wiersze, także wartości podpowiedziane. Gdy zlecenie nie ma typu pojazdu, pole mówi wprost, że potwierdzasz domyślny typ floty (JUMBO).',
      action: 'Sprawdź wiersze i zaznacz „Potwierdzam dane do publikacji”.',
      recorder: {
        account: 'trade',
        demo: { kind: 'order', number: 'DEMO/2026/10/C02' },
        actions: [
          { kind: 'clickButton', name: 'Wystaw na TIMOCOM' },
          { kind: 'click', target: 'trd-zlecenie-dane-potwierdz' },
        ],
      },
    },
    {
      route: '/user-offers/:orderId/show',
      record: TRADE_ORDER,
      target: 'trd-publikacja-publikuj',
      mockupTestId: 'trd-publikacja-publikuj',
      title: '„Wystaw” dopiero po potwierdzeniu',
      description:
        'Bez potwierdzenia danych „Wystaw” jest nieaktywny, nawet gdy reszta okna jest wypełniona. Po wystawieniu wynik w sekcji „Publikacje na giełdach” i historia zlecenia mówią, że dane potwierdzono, kto to zrobił i jaki pojazd poszedł na giełdę.',
      action: 'Zaznacz potwierdzenie danych i pozostałe pola okna, potem kliknij „Wystaw”.',
      recorder: {
        account: 'trade',
        demo: { kind: 'order', number: 'DEMO/2026/10/C02' },
        actions: [{ kind: 'clickButton', name: 'Wystaw na TIMOCOM' }],
      },
    },
  ],
};
